export const GraduationCupIcon = ({ fill = '#469D18' }) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.938V16H17V18H5V16H10V13.938C8.0667 13.6942 6.28882 12.7533 5 11.2917C3.71119 9.83023 3.00003 7.94861 3 6V0H19V6C19 7.94861 18.2888 9.83023 17 11.2917C15.7112 12.7533 13.9333 13.6942 12 13.938V13.938ZM0 2H2V6H0V2ZM20 2H22V6H20V2Z"
        fill={fill}
      />
    </svg>
  );
};
